module.exports = __webpack_public_path__ + "img/loader.fdd16660.svg";